
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-736542df&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ChangelogView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChangelogView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-736542df!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChangelogView.vue"),
  /* scopeId */
  "data-v-736542df",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/views/ChangelogView.vue
// module id = ./dev/src/views/ChangelogView.vue
// module chunks = 0